var _filter, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    viewBox: "-100 -100 961 1001",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "blurFilter"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 35
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M380.5 0.5L427.714 255.191L615.614 76.8932L504.107 310.694L760.923 276.893L533.286 400.5L760.923 524.107L504.107 490.306L615.614 724.107L427.714 545.808L380.5 800.5L333.286 545.808L145.386 724.107L256.893 490.306L0.0773926 524.107L227.714 400.5L0.0773926 276.893L256.893 310.694L145.386 76.8932L333.286 255.191L380.5 0.5Z",
    fill: "currentColor",
    filter: "url(#blurFilter)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.b1b0bce87e37b5f5952de06ffb5e2ac9.svg";
export { ForwardRef as ReactComponent };